import BlueDotsBackground from '../../BlueDotsBackground';
// import people from '../../content/people';

export default function Articles() {
  return (
    <>
      <BlueDotsBackground />

      <section id="header" className="text-white px-6 py-8">
        <div className="max-w-4xl mx-auto">
          <header className="text-left">
            <h1 className="text-4xl font-bold text-white">
              MFP Impacts on Gross-to-Net Operations
            </h1>

            <div className="mt-4 flex items-center justify-start gap-4">
              <div className="text-sm text-gray-400">
                <p>07/07/2025</p>
                <p>Written by Sushila Rau</p>
              </div>
              {/* <img
                                src={people[10].image}
                                alt={people[10].name}
                                className="w-10 h-10 rounded-full object-cover border-2 border-white/30 shadow-md"
                            /> */}
            </div>
          </header>
        </div>
      </section>

      {/* Article Section */}
      <section id="article" className="text-white px-6 py-4">
        <div className="flex items-center justify-center min-h-screen">
          <div className="mb-24 max-w-2xl px-4 text-left">
            <p className="text-sm text-gray-300">
              <span className="font-bold text-white">
                Starting January 1, 2026, CMS will implement the initial set of
                Maximum Fair Prices (MFPs) for certain single-source drugs
                covered under Medicare Part D, as outlined in the Inflation
                Reduction Act. MFP impacts a manufacturer's Gross-to-Net (GTN)
                by reducing the net dollars a manufacturer receives after the
                initial sale.{' '}
              </span>{' '}
              <br />
              <br />
              As regulatory requirements and market strategies evolve, GTN
              operations have become increasingly challenging. Despite this
              complexity, GTN remains a critical financial process that informs
              accurate forecasting and is integral to pricing and contracting
              strategies. As such, maintaining GTN visibility and adaptability
              under new MFP constraints will be essential to effective
              operational planning and revenue management.
              <br />
              <br />
              <span className="font-bold text-white">
                <i className="fas fa-arrows-split-up-and-left mr-2 text-2xl"></i>
                New Channels{' '}
              </span>{' '}
              <br />
              <br />
              With the implementation of MFP, manufacturers can expect selected
              drugs acquired by pharmacies to later be dispensed to
              Medicare-eligible patients. Similar to existing channels, such as
              Medicaid, this will require establishing reserves to cover future
              rebate obligations and implementing systems to manage the new MFP
              reserve channel. Systems used to track the MFP channel should also
              support the full range of GTN activities, including actuals to
              forecasting, without requiring costly infrastructure changes or
              operational downtime.
              <br />
              <br />
              <span className="font-bold text-white">
                <i className="fas fa-folder-arrow-down mr-2 text-2xl"></i>
                Ability to Ingest MFP Data
              </span>{' '}
              <br />
              <br />
              A successful GTN system must be capable of incorporating MFP
              payments to ensure accuracy of actuals at the time of
              implementation and to continuously track reserves over time. Since
              MFP has not yet gone into full effect, no existing system has
              real-world experience ingesting or processing this specific rebate
              data. A GTN solution must therefore be designed with the
              flexibility to rapidly ingest large and evolving datasets, ensure
              compliance, and support accurate actuals tracking from day one.
              <br />
              <br />
              <span className="font-bold text-white">
                <i className="fas fa-chart-line mr-2 text-2xl"></i>
                Forecasting Capabilities
              </span>{' '}
              <br />
              <br />
              Forecasting plays a critical role in the GTN function but is often
              challenged by pricing adjustments, variation across channels, and
              high data volumes. With MFP introducing a new data stream,
              forecasting systems must be capable of integrating this channel
              into their models. Additionally, these systems must be dynamic and
              capable of modeling accrual rates that account for the distinct
              discounts, rebates, and payment dynamics across every channel,
              including MFP.
              <br />
              <br />
              <span className="font-bold text-white">
                <i className="fas fa-puzzle mr-2 text-2xl"></i>
                Individualized Systems
              </span>{' '}
              <br />
              <br />
              GTN processes are highly individualized and vary significantly
              across manufacturers. Traditional spreadsheet-based approaches can
              offer the flexibility needed to support these individual
              processes, but ultimately struggle to scale and remain performant.
              Alternatively, software solutions can offer the performance
              necessary for large volumes of data but often impose rigid
              processes. Both challenges will only grow with the upcoming
              introduction of MFP data. To remain effective, GTN systems must
              offer adaptable frameworks that can accommodate each
              manufacturer’s unique workflows and data requirements while
              simultaneously handling increasingly large data volumes and
              maintaining performance.
              <br />
              <br />
              <span className="font-bold text-white">
                <i className="fas fa-arrow-right mr-2 text-2xl"></i>
                Looking Ahead
              </span>{' '}
              <br />
              <br />
              Preparing for the future of drug pricing under MFP requires
              systems that are fast, flexible, and transparent. At the same
              time, they must maintain compliance across operations. To stay
              ahead, manufacturers need a GTN solution that can seamlessly
              ingest new data, support accurate actuals tracking and
              forecasting, and accommodate the individualized processes unique
              to each organization.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
